<div class="modal-header">
    <h5 class="modal-title">Ürün Güncelle</h5>
    <button type="button" class="close" (click)="close()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<form [formGroup]="productForm">
    <div class="modal-body">

        <section class="vertical-wizard">
            <div id="stepper2" class="bs-stepper vertical vertical-wizard-example">
                <div class="bs-stepper-header">
                    <div class="step" data-target="#account-details-vertical">
                        <button type="button" class="step-trigger">
                            <span class="bs-stepper-box">1</span>
                            <span class="bs-stepper-label">
                                <span class="bs-stepper-title">Ürün / Hizmet</span>
                                <span class="bs-stepper-subtitle">Ürün / Hizmet Detayı</span>
                            </span>
                        </button>
                    </div>
                    <div class="step" data-target="#social-links-vertical">
                        <button type="button" class="step-trigger">
                            <span class="bs-stepper-box">2</span>
                            <span class="bs-stepper-label">
                                <span class="bs-stepper-title">Varyant</span>
                                <span class="bs-stepper-subtitle">Varyant Detayı</span>
                            </span>
                        </button>
                    </div>
                </div>
                <div class="bs-stepper-content">
                    <div id="account-details-vertical" class="content">
                        <div class="content-header">
                            <h5 class="mb-0">Ürün / Hizmet Detay</h5>
                        </div>
                        <div class="row">
                            <div class="col-xl-3 col-md-6 col-sm-12">
                                <label class="form-label d-block">Ürün \ Hizmet Türü *</label>
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="productType2" class="custom-control-input"
                                        formControlName="productType" [value]="false">
                                    <label class="custom-control-label" for="productType2">Hizmet</label>
                                </div>

                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="productType1" class="custom-control-input"
                                        formControlName="productType" [value]="true">
                                    <label class="custom-control-label" for="productType1">Ürün</label>
                                </div>
                            </div>
                            <div class="col-xl-9 col-md-12 col-sm-12">
                                <label class="form-label">Ürün Adı *</label>
                                <input type="text" class="form-control" formControlName="name" />
                            </div>



                            <div class="col-xl-3 col-md-6 col-sm-6" *ngIf="productType">
                                <label class="form-label">Alış Fiyatı</label>
                                <input type="number" class="form-control" formControlName="purchasePrice" />
                            </div>

                            <div class="col-xl-3 col-md-6 col-sm-6">
                                <label class="form-label">Satış Fiyatı</label>
                                <input type="number" class="form-control" formControlName="salePrice" />
                            </div>

                            <div class="col-xl-3 col-md-6 col-sm-6" *ngIf="productType">
                                <label class="form-label">Alış Vergisi</label>
                                <ng-select [items]="taxes" bindLabel="taxRate" bindValue="id" [clearable]="true"
                                    placeholder="Seçiniz" formControlName="purchaseTaxId">
                                </ng-select>
                            </div>
                            <div class="col-xl-3 col-md-6 col-sm-6">
                                <label class="form-label">Satış Vergisi</label>
                                <ng-select [items]="taxes" bindLabel="taxRate" bindValue="id" [clearable]="true"
                                    placeholder="Seçiniz" formControlName="saleTaxId">
                                </ng-select>
                            </div>

                            <!-- Para Birimi -->
                            <div class="col-xl-3 col-md-6 col-sm-6">
                                <label class="form-label">Para Birimi *</label>
                                <ng-select [items]="currencies" bindLabel="currencyName" bindValue="id"
                                    [clearable]="true" placeholder="Seçiniz" formControlName="currencyId">
                                </ng-select>
                            </div>

                            <!-- Tür -->
                            <div class="col-xl-3 col-md-6 col-sm-6" *ngIf="!productType">
                                <label class="form-label">Tür *</label>
                                <ng-select [items]="kinds" bindLabel="typeName" bindValue="id" [clearable]="true"
                                    placeholder="Seçiniz" formControlName="kindId">
                                </ng-select>
                                <div *ngIf="productForm.get('kindId')?.invalid && productForm.get('kindId')?.touched"
                                    class="text-danger mt-25">
                                    Tür seçimi zorunludur.
                                </div>
                            </div>

                            <!-- Kategori -->
                            <div class="col-xl-3 col-md-6 col-sm-6" *ngIf="productType">
                                <label class="form-label">Kategori</label>
                                <ng-select [items]="categories" bindLabel="categoryName" bindValue="id"
                                    [clearable]="true" placeholder="Seçiniz" formControlName="categoryId">
                                </ng-select>
                            </div>

                            <!-- Birim Tipi -->
                            <div class="col-xl-3 col-md-6 col-sm-6" *ngIf="productType">
                                <label class="form-label">Birim Tipi</label>
                                <ng-select [items]="unitTypes" bindLabel="unitTypeName" bindValue="id"
                                    [clearable]="true" placeholder="Seçiniz" formControlName="unitTypeId">
                                </ng-select>
                            </div>

                            <!-- Marka / Model -->
                            <div class="col-xl-3 col-md-6 col-sm-6" *ngIf="productType">
                                <label class="form-label">Marka / Model</label>
                                <ng-select [items]="brands" bindLabel="name" bindValue="id" groupBy="brandName">
                                    <ng-template ng-optgroup-tmp let-item="item">
                                        {{ item.brandName || 'Unnamed group' }}
                                    </ng-template>
                                </ng-select>
                            </div>

                            <div class="col-xl-3 col-md-6 col-sm-6">
                                <label class="form-label">Barkod</label>
                                <input type="text" class="form-control" formControlName="barcode" />
                            </div>

                            <div class="col-xl-3 col-md-6 col-sm-6">
                                <label class="form-label">Ürün Kodu</label>
                                <input type="text" class="form-control" formControlName="code" />
                            </div>

                            <!-- Etiketler -->
                            <div class="col-xl-6 col-md-12 col-sm-12">
                                <label class="form-label">Etiketler</label>
                                <div class="form-control p-2" style="min-height: 100px; overflow-y: auto;">
                                    <div class="d-flex flex-wrap gap-2">
                                        <span class="badge bg-primary"
                                            *ngFor="let label of productForm.get('labels')?.value">
                                            {{ label.labelName }}
                                            <i class="ms-1 cursor-pointer"
                                                (click)="removeLabel(label.productLabelId)">×</i>
                                        </span>
                                    </div>

                                    <input type="text" class="border-0 mt-2 w-100" style="outline: none;"
                                        placeholder="Etiket Giriniz" [(ngModel)]="newLabel"
                                        [ngModelOptions]="{ standalone: true }" (keydown.enter)="addLabel($event)" />
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <button class="btn btn-outline-secondary btn-prev" disabled rippleEffect>
                                <i data-feather="arrow-left" class="align-middle mr-sm-25 mr-0"></i>
                                <span class="align-middle d-sm-inline-block d-none">Previous</span>
                            </button>
                            <button type="button" class="btn btn-primary btn-next" (click)="verticalWizardNext()"
                                rippleEffect>
                                <span class="align-middle d-sm-inline-block d-none">İleri</span>
                                <i data-feather="arrow-right" class="align-middle ml-sm-25 ml-0"></i>
                            </button>
                        </div>
                    </div>
                    <div id="social-links-vertical" class="content">
                        <div class="content-header">
                            <h5 class="mb-0">Varyantlar</h5>
                            <small>Enter Your Social Links.</small>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label class="form-label" for="variantSelect">Varyant Seç</label>
                                <ng-select [items]="varyants" bindLabel="name" [(ngModel)]="selectedVaryants"
                                    [ngModelOptions]="{ standalone: true }" [multiple]="true"
                                    placeholder="Varyant Seçiniz" (change)="onVariantSelectChange()">
                                    <ng-template ng-header-tmp>
                                        <button
                                            class="add-new-customer btn btn-flat-success cursor-pointer rounded-0 text-left p-50 w-100"
                                            (click)="showCreateVariant()">
                                            <i data-feather="plus"></i>
                                            <span class="align-middle ml-25">Yeni Varyant Ekle</span>
                                        </button>
                                    </ng-template>
                                    <ng-template ng-option-tmp let-item="item">
                                        {{ item.name }} <span *ngIf="item.secondName">- {{ item.secondName }}</span>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                        <section id="draggable-cards">
                            <div cdkDropList [cdkDropListData]="product.productVaryants"
                                (cdkDropListDropped)="dropVariant($event)" class="row mt-2 g-2">

                                <div class="col-xl-3 col-md-6 col-sm-12 mb-1"
                                    *ngFor="let varyant of product.productVaryants; let i = index" cdkDrag>

                                    <div class="card h-100" [ngClass]="{ 'opacity-50': !varyant.isActive }"
                                        cdkDragHandle>

                                        <!-- Header -->
                                        <div class="card-header bg-light-primary text-center py-2">
                                            <!-- Üstte varyant adı -->
                                            <p class="fw-bold mb-50 text-truncate text-center w-100">{{ varyant.name }}
                                            </p>

                                            <!-- Altta switchler yan yana -->
                                            <div class="d-flex justify-content-between align-items-center w-100">
                                                <!-- Zorunlu switch -->
                                                <div class="d-flex flex-column align-items-center">
                                                    <label class="mb-25 fw-bold small text-white">
                                                        {{ varyant.isRequired ? 'Zorunlu' : 'Zor. Değil' }}
                                                    </label>
                                                    <div class="custom-control-success custom-switch">
                                                        <input type="checkbox" [(ngModel)]="varyant.isRequired"
                                                            [ngModelOptions]="{ standalone: true }"
                                                            class="custom-control-input"
                                                            [id]="'switch-required-' + (varyant.ProductVariantDefinitionId ?? varyant.productVariantDefinitionId)" />
                                                        <label class="custom-control-label"
                                                            [for]="'switch-required-' + (varyant.ProductVariantDefinitionId ?? varyant.productVariantDefinitionId)"></label>
                                                    </div>
                                                </div>

                                                <!-- Aktif switch -->
                                                <div class="d-flex flex-column align-items-center">
                                                    <label class="mb-25 fw-bold small text-white">
                                                        {{ varyant.isActive ? 'Aktif' : 'Pasif' }}
                                                    </label>
                                                    <div class="custom-control-success custom-switch">
                                                        <input type="checkbox" [(ngModel)]="varyant.isActive"
                                                            [ngModelOptions]="{ standalone: true }"
                                                            class="custom-control-input"
                                                            [id]="'switch-active-' + (varyant.ProductVariantDefinitionId ?? varyant.productVariantDefinitionId)" />
                                                        <label class="custom-control-label"
                                                            [for]="'switch-active-' + (varyant.ProductVariantDefinitionId ?? varyant.productVariantDefinitionId)"></label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <!-- Body -->
                                        <div class="card-body p-1">
                                            <!-- Tip 1: Seçenekli -->
                                            <div *ngIf="getVariantType(varyant) === 1">
                                                <label class="fw-bold">Seçenekler</label>
                                                <div cdkDropList [cdkDropListData]="varyant.productVariantOptions"
                                                    (cdkDropListDropped)="dropOption(varyant, $event)"
                                                    style="max-height: 150px; overflow-y: auto;">

                                                    <div class="d-flex align-items-center mb-1"
                                                        *ngFor="let opt of varyant.productVariantOptions; let j = index"
                                                        cdkDrag>
                                                        <span class="drag-handle me-2" cdkDragHandle title="Taşı">
                                                            <i data-feather="menu"></i>
                                                        </span>
                                                        <input type="text" class="form-control form-control-sm me-1"
                                                            [(ngModel)]="opt.name" placeholder="Seçenek adı"
                                                            [ngModelOptions]="{ standalone: true }" />
                                                        <button class="btn btn-sm btn-flat-danger"
                                                            (click)="removeOption(varyant, j)">
                                                            <i data-feather="x"></i>
                                                        </button>
                                                    </div>
                                                </div>

                                                <button type="button" class="btn btn-sm btn-success mt-1"
                                                    (click)="addOption(varyant)">
                                                    <i data-feather="plus"></i>
                                                </button>
                                            </div>

                                            <!-- Tip 2: True/False -->
                                            <div *ngIf="getVariantType(varyant) === 2" class="mt-1">
                                                <label class="fw-bold">Doğru</label>
                                                <input type="text" class="form-control form-control-sm mb-1"
                                                    [(ngModel)]="varyant.trueLabel" placeholder="Doğru" />
                                                <label class="fw-bold">Yanlış</label>
                                                <input type="text" class="form-control form-control-sm"
                                                    [(ngModel)]="varyant.falseLabel" placeholder="Yanlış" />
                                            </div>

                                            <!-- Tip 3: Metin Tipi -->
                                            <div *ngIf="getVariantType(varyant) === 3" class="mt-1 text-muted">
                                                <small>Bu varyant metin tipidir, ek input gerekmez.</small>
                                            </div>
                                        </div>

                                        <!-- Footer -->
                                        <div class="card-footer d-flex justify-content-between align-items-center">
                                            <small>Sıra: {{ varyant.displayOrder }}</small>
                                            <div>
                                                <i data-feather="move" cdkDragHandle></i>

                                                <button type="button" class="btn btn-danger ml-1" appDelete
                                                    controller="ProductVaryants" [id]="varyant.id"
                                                    (callback)="getByIdProduct(product.id)" title="Sil"
                                                    *ngIf="varyant.id">
                                                    <i data-feather="trash-2"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <div class="d-flex justify-content-between">
                            <button type="button" class="btn btn-primary btn-prev" (click)="verticalWizardPrevious()"
                                rippleEffect>
                                <i data-feather="arrow-left" class="align-middle mr-sm-25 mr-0"></i>
                                <span class="align-middle d-sm-inline-block d-none">Geri</span>
                            </button>
                            <button class="btn btn-success" type="button" rippleEffect (click)="onSubmit()"
                                [disabled]="productForm.invalid">Kaydet</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</form>